import "./style.scss";

export function why_us_block() {
  const block = document.querySelector(".why_us_block");
  if (!block) return;
}
